import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

export interface SupabaseEnvInput {
  VITE_SUPABASE_URL?: string;
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
  VITE_SUPABASE_ANON_KEY?: string;
}

export interface SupabaseEnv {
  url: string | undefined;
  key: string | undefined;
}

function normalize(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

export function readSupabaseEnv(env: SupabaseEnvInput): SupabaseEnv {
  return {
    url: normalize(env.VITE_SUPABASE_URL),
    key: normalize(env.VITE_SUPABASE_PUBLISHABLE_KEY ?? env.VITE_SUPABASE_ANON_KEY),
  };
}

export function isSupabaseConfigured(env: SupabaseEnv): boolean {
  return Boolean(env.url && env.key);
}

export function createSupabaseClient(env: SupabaseEnv): SupabaseClient<Database> | null {
  if (!env.url || !env.key) return null;
  return createClient<Database>(env.url, env.key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

export const supabaseEnv = readSupabaseEnv(import.meta.env);
export const supabase = createSupabaseClient(supabaseEnv);
export const supabaseConfigured = isSupabaseConfigured(supabaseEnv);
